import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  // Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  Dropdown,
  Tooltip,
  OverlayTrigger,
  // ListGroup,
  Accordion,
  Card,
  Table,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import CustomNavbar from "../../../components/CustomNavbar";
import SidebarEvaluacionDesempenio from "../../../components/evaluacion_desempenio/SidebarEvaluacionDesempenio";
// import { getPlazasVacantes } from "../../../redux/seleccionContratacion/plazas_vacantes/actions";
//import { getFactor } from "../../../redux/evaluacion_desempenio/Factor/actions";
import { get_tasks_descriptors } from "../../../redux/tasks/actions";
import { Link, useHistory } from "react-router-dom";
import LinkDescriptor from "../../../components/evaluacion_desempenio/LinkDescriptor";
import { getGeneralInfo } from "../../../redux/descriptorsProfiles/GeneralInfo/actions";
//import { getTraining } from "../../../redux/descriptorsProfiles/Formation/actions";
//import { getPreparation } from "../../../redux/descriptorsProfiles/Preparation/actions";
//import { getTechnicalKnowledgeAcquired } from "../../../redux/descriptorsProfiles/TechnicalKnowledgeAcquired/actions";
//import { getExperience } from "../../../redux/descriptorsProfiles/Experience/actions";
//import { getIndikators } from "../../../redux/descriptorsProfiles/indikators/actions";
//import { getJobFunction } from "../../../redux/descriptorsProfiles/JobFunction/actions";
//import Question from "../../../components/evaluacion_desempenio/Question";
import QuestionCompetencyComponent from "../../../components/evaluacion_desempenio/QuestionCompetency";
//import { getFactorTemplate } from "../../../redux/evaluacion_desempenio/CompetencyTemplate/actions"
import {
  getPesoCompetencias,
  // resetPesoCompetencias,
} from "../../../redux/evaluacion_desempenio/pesoCompetencia/actions";
import {
  getClassification,
  // saveClassification,
  // editClassification,
  // deleteClassification,
} from "../../../redux/Classification/actions";

import {
  getCompetencyQuestions,
  // deleteCompetencyQuestion,
  // editCompetencyQuestion,
  // saveCompetencyQuestion,
} from "../../../redux/evaluacion_desempenio/competencyEvaluationQuestions/actions";
import {
  // getPlantillaCompetencias,
  // deletePlantillaCompetencia,
  // editPlantillaCompetencia,
  // savePlantillaCompetencia,
  getPlantillaCompetencia,
} from "../../../redux/evaluacion_desempenio/CompetencyTemplate/actions";

const CompetencyQuestions = (props) => {
  const filtersFuncion = [
    { id: "descripcion", desc: "Descripción función" },
    { id: "codigo", desc: "Codigo de función" },
  ];
  // const filters = [
  //   { id: "posicion__nombre", desc: "Descripción posición" },
  //   { id: "posicion__codigo", desc: "Codigo de posición" },
  // ];

  const [_funcion, setFuncion] = useState(false);
  const [_viewMessege, setViewMessege] = useState(false);
  const [_continue, setContinue] = useState(true);
  const [alphabet, setAlphabet] = useState([]);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  // const [showModal, setShowModal] = useState(false);
  // const [edit, setEdit] = useState(false);
  // const [validated, setValidated] = useState(false);
  const [orderAlphabetic, setOrderAlphabetic] = useState(true);
  const [descriptorCompleto, setDescriptorCompleto] = useState(false);
  const [showModalFunction, setShowModalFunction] = useState(false);
  // const [showModalPosition, setShowModalPosition] = useState(false);
  const [show, setShow] = useState(false);
  const [functionSelected, setFunctionSelected] = useState(null);
  // const [validatedFunction, setValidatedFunction] = useState(false);
  // const [positionSelected, setPositionSelected] = useState(null);
  const [filter, setFilter] = useState("");
  // const [resetFunction, setResetFunction] = useState(false);

  // const data = useSelector((store) => store.classification.classification);
  // const loading = useSelector((store) => store.classification.loading);

  const [tipoBusquedaFuncion, setTipoBusquedaFuncion] = useState({
    id: "descripcion",
    desc: "Descripción función",
  });
  // const [tipoBusquedaPosition, setTipoBusquedaPosition] = useState({
  //   id: "posicion__codigo",
  //   desc: "Descripción posición",
  // });

  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "nombre",
    desc: "Competencia",
  });

  const dispatch = useDispatch();
  const history = useHistory();

  // const { loading, factorsLength, factors, factorError } = useSelector(
  //   (store) => store.factor
  // );

  const {
    loaderPesoCompetencia,
    pesoCompetencia,
    // pesoCompetenciaFalla,
    // saveLoaderPesoCompetencia,
    // pesoCompetenciaFormError,
    // pesoCompetencias,
  } = useSelector((store) => store.pesoCompetencia);

  const { tasks, loader, tasksLength } = useSelector((store) => store.tasks);

  // Descriptor de la función
  const {
    loading: loadingGeneralInfo,
    generalInfos,
    // generalInfosLength,
    // generalInfoError,
  } = useSelector((store) => store.generalInfo);

  const {
    loading: jobLoading,
    // jobFunctionsLength,
    // jobFunctions,
  } = useSelector((store) => store.jobFunction);

  const { loaderIndikators, indikators } = useSelector(
    (store) => store.indikators
  );

  // const getAClassification = (filt = filter) =>
  //   dispatch(
  //     getClassification(
  //       {
  //         filter: filt,
  //       },
  //       2
  //     )
  //   );

  const _getCompetencia = (filt = filter) =>
    dispatch(
      getPesoCompetencias({
        tipo_busqueda: "periodicidad_id",
        filter: props.match.params.idPeriodicidad,
        tipo_busqueda_2: "clasificacion_id",
        filter_2: filt,
      })
    );

  const {
    loading: trainingLoading,
    // trainingsLength,
    // trainings,
  } = useSelector((store) => store.training);

  const {
    loading: preparationLoading,
    // preparationsLength,
    // preparations,
  } = useSelector((store) => store.preparation);

  const {
    loading: technicalKnowledgeAcquiredLoading,
    // technicalKnowledgeAcquiredsLength,
    // technicalKnowledgeAcquireds,
  } = useSelector((store) => store.technicalKnowledgeAcquired);

  const {
    loading: experienceLoading,
    // experiencesLength,
    // experiences,
  } = useSelector((store) => store.experience);

  let funcionOptions = [];
  tasks &&
    tasks.map((task) => {
      funcionOptions = [
        ...funcionOptions,
        {
          id: task.id,
          label: task.descripcion
            ? `${task.codigo} / ${task.descripcion.toUpperCase()}`
            : "",
          item: task,
        },
      ];
    });

  let factorSorted = [];
  pesoCompetencia &&
    pesoCompetencia.data.map((fact, index) => {
      if (parseInt(index) > 1) {
        factorSorted.push(fact);
      }
    });

  const {
    loaderPlantillaCompetencia,
    plantillaCompetencia,
    // plantillaCompetenciaFalla,
    // plantillaCompetenciaFormError,
  } = useSelector((store) => store.plantillaCompetencia);

  // Métodos

  useEffect(() => {
    // _getCompetencia();
    // dispatch(resetPesoCompetencias());
    // getAClassification({});
    dispatch(getPlantillaCompetencia(parseInt(props.match.params.idPlantilla)));
  }, [props.match.params.idPlantilla]);

  useEffect(() => {
    if (plantillaCompetencia && plantillaCompetencia.id) {
      _getCompetencia(plantillaCompetencia.list_periodicidad[0].clasificacion);
    }
  }, [plantillaCompetencia]);

  useEffect(() => {
    if (pesoCompetencia) {
      //  debugger;
      const _factorSorted = [];
      pesoCompetencia.data.map((fact, index) => {
        _factorSorted.push(fact);
      });
      const sorted = [..._factorSorted].sort((a, b) =>
        a.list_competencia[0].nombre > b.list_competencia[0].nombre
          ? 1
          : b.list_competencia[0].nombre > a.list_competencia[0].nombre
          ? -1
          : 0
      );
      console.log("sorted: ", sorted);
      setAlphabet(sorted);
    }
  }, [pesoCompetencia]);

  // const onAddFunction = () => {
  //   setShowModalFunction(true);
  //   setFuncion(false);
  //   setViewMessege(false);
  //   setContinue(true);
  // };

  // const onAddPosition = () => {
  //   setShowModalPosition(true);
  // };

  const onSearchFunction = (e) => {
    if (e.key === "Enter") {
      if (!!e.target.value.trim()) {
        setViewMessege(false);
        setContinue(true);
        dispatch(
          get_tasks_descriptors({
            filter: e.target.value,
            tipo_busqueda: tipoBusquedaFuncion.id,
          })
        );
      }
    }
  };

  // const onSearchPosition = (e) => {
  //   if (e.key === "Enter") {
  //     if (!!e.target.value.trim()) {
  //       dispatch(
  //         getPlazasVacantes({
  //           filter: e.target.value,
  //           tipo_busqueda: tipoBusquedaPosition.id,
  //         })
  //       );
  //     }
  //   }
  // };

  const _getCompetencyQuestions = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getCompetencyQuestions({
        offset: offs,
        limit: lim,
        tipo_busqueda: "posicion_id",
        filter: parseInt(props.match.params.id),
        tipo_busqueda_2: tipoBusqueda.id,
        filter_2: filt,
      })
    );

  // const seeAll = () => {
  //   const oSearch = "";
  //   setFilter(oSearch);
  //   const oOffset = 0;
  //   setOffset(oOffset);
  //   setCurrentPage(1);
  //   _getCompetencyQuestions(oOffset, limit, oSearch);
  // };

  // const onAdd = () => {
  //   setShowModal(true);
  //   setEdit(false);
  //   setValidated(false);
  // };

  // const onSearch = (e) => {
  //   e.preventDefault();
  //   setFilter(e.currentTarget.value);
  //   _getCompetencia(e.currentTarget.value);
  // };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarEvaluacionDesempenio show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-start align-items-center">
            <Row className="justify-content-end align-items-center flex-nowrap">
              {" "}
            </Row>{" "}
            <Button
              onClick={() =>
                history.push(
                  `/evaluacion-desempenio/admin/preguntas-por-competencia`
                )
              }
              variant="link"
              className="font-weight-bold mr-4 text-dark"
            >
              <i className="material-icons">arrow_back</i>
            </Button>
            <h6 className="font-weight-bold text-uppercase">
              Preguntas de evaluación por competencia
            </h6>
          </div>

          <Col sm="12" md="12">
            <hr />
          </Col>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-end align-items-center">
            <Form
            // onSubmit={onSearch}
            >
              <Row className="justify-content-sm-end align-items-center flex-nowrap">
                {/* <Form.Control
                  as="select"
                  className=" rounded-pill"
                  onChange={(e) => {
                    onSearch(e);
                  }}
                >
                  <option value="">Seleccionar clasificación...</option>
                  {data
                    .sort((a, b) =>
                      a.nombre > b.nombre ? 1 : b.nombre > a.nombre ? -1 : 0
                    )
                    .map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.nombre}
                      </option>
                    ))}
                </Form.Control> */}
                <Col xs="auto">
                  <ButtonGroup>
                    <Link
                      className="btn btn-primary rounded-pill mr-1 d-flex flex-wrap justify-content-center align-items-center"
                      style={{ textDecoration: "none" }}
                      to={`/evaluacion-desempenio/admin/pesoCompetencia`}
                      // target="_blank"
                    >
                      Corregir pesos
                    </Link>
                    <Button
                      variant="primary"
                      size="sm"
                      className="rounded mr-3"
                      onClick={() => {
                        const _orderAlphabetic = orderAlphabetic;
                        setOrderAlphabetic(!orderAlphabetic);
                        if (!_orderAlphabetic) {
                          const sorted = [...alphabet].sort((a, b) =>
                            a.list_competencia[0].nombre >
                            b.list_competencia[0].nombre
                              ? 1
                              : b.list_competencia[0].nombre >
                                a.list_competencia[0].nombre
                              ? -1
                              : 0
                          );
                          setAlphabet(sorted);
                        } else {
                          setAlphabet(pesoCompetencia.data);
                        }
                      }}
                    >
                      <i className="material-icons">sort_by_alpha</i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {loaderPesoCompetencia || loaderPlantillaCompetencia ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            pesoCompetencia &&
            pesoCompetencia.count > 0 && (
              <>
                <Col>
                  {alphabet.map((item, _index) => (
                    <>
                      <div key={item.id} className="my-3">
                        <Accordion>
                          <Card>
                            <Accordion.Toggle
                              as={Card.Header}
                              eventKey={toString(_index)}
                              className="bg-acordion-factor d-flex flex-wrap justify-content-between align-items-center"
                            >
                              <div className="d-flex flex-wrap justify-content-between align-items-center">
                                <i className="material-icons mr-2">
                                  control_point
                                </i>{" "}
                                {item.list_competencia[0].nombre}
                              </div>
                              <div className="d-flex flex-wrap justify-content-between align-items-center">
                                Clasificación:{" "}
                                {item.list_clasificacion[0].nombre}
                                &nbsp; &nbsp; &nbsp; Peso: {item.peso} %
                              </div>
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={toString(_index)}>
                              <Card.Body>
                                <Container>
                                  <QuestionCompetencyComponent
                                    index={parseInt(_index) + 2}
                                    item={item}
                                    _viewMessege={_viewMessege}
                                    idPeriodicidad={
                                      props.match.params.idPeriodicidad
                                    }
                                    idPlantilla={props.match.params.idPlantilla}
                                  />
                                </Container>
                              </Card.Body>
                            </Accordion.Collapse>
                          </Card>
                        </Accordion>
                      </div>
                    </>
                  ))}
                </Col>
              </>
            )
          )}
          {!loaderPesoCompetencia &&
            pesoCompetencia &&
            pesoCompetencia.count === 0 &&
            (
              <Alert variant="info" className="my-4">
                Aún no hay pesos por competencia registrados, comience agregando
                algunos
              </Alert>
            )}
          {/* {!loaderPesoCompetencia && filter === "" && (
            <Alert variant="info" className="my-4">
              Seleccione una clasificación.
            </Alert>
          )} */}
        </Container>
      </div>
      <Modal
        show={showModalFunction}
        onHide={() => setShowModalFunction(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-muted">Seleccionar función</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="justify-content-end align-items-center flex-nowrap">
            <Col xs="auto">
              <Form.Label className="m-0" htmlFor="filterEmployee">
                <b>{tipoBusquedaFuncion.desc}:</b>
              </Form.Label>
            </Col>
            <Col xs="auto">
              <Form.Control
                id="filterEmployee"
                name="filterEmployee"
                className={`rounded-pill form-control-sm`}
                type="search"
                onKeyDown={onSearchFunction}
              ></Form.Control>
              <Form.Control.Feedback type="invalid">
                **Campo requerido
              </Form.Control.Feedback>
            </Col>
            <Col>
              <ButtonGroup>
                <OverlayTrigger
                  placement="auto"
                  overlay={<Tooltip {...props}>Seleccionar Filtrado</Tooltip>}
                >
                  <Dropdown className="ml-3 mr-3">
                    <Dropdown.Toggle variant="primary" className="btn-sm font">
                      <i className="material-icons">filter_list</i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {filtersFuncion.map((item) => (
                        <Dropdown.Item
                          onClick={() => setTipoBusquedaFuncion(item)}
                          key={item.id}
                        >
                          {item.desc}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </OverlayTrigger>
              </ButtonGroup>
            </Col>
          </Row>
          <div className="my-3">
            {loader ? (
              <div className="d-flex justify-content-center">
                <Spinner
                  animation="border"
                  role="status"
                  className="d-flex justify-content-center"
                />
              </div>
            ) : tasksLength > 0 ? (
              <div>
                {!loadingGeneralInfo &&
                !jobLoading & !loaderIndikators &&
                _viewMessege &&
                _funcion &&
                generalInfos.length === 0 ? (
                  <div className="mb-1 border-left border-danger">
                    <Alert className="mb-0" variant="light">
                      <p>
                        No existe un descriptor para esta función, ¿Desea
                        agregar uno,{" "}
                        <Link
                          to={`/descriptores-perfiles/seleccion-del-descriptor/${
                            functionSelected && functionSelected.id
                              ? functionSelected.id
                              : ""
                          }/${
                            functionSelected && functionSelected.descripcion
                              ? functionSelected.descripcion
                              : ""
                          }`}
                          // target="_blank"
                        >
                          si
                        </Link>{" "}
                        o{" "}
                        <Link
                          onClick={() => {
                            setViewMessege(false);
                            setContinue(false);
                          }}
                        >
                          no
                        </Link>
                        ?
                      </p>
                    </Alert>
                  </div>
                ) : null}
                {!loadingGeneralInfo &&
                !jobLoading &&
                // !experienceLoading &&
                // !technicalKnowledgeAcquiredLoading &&
                // !preparationLoading &&
                // !trainingLoading &&
                !loaderIndikators &&
                !descriptorCompleto &&
                _viewMessege &&
                _funcion &&
                generalInfos.length !== 0 ? (
                  <div className="mb-1 border-left border-danger">
                    <Alert className="mb-0" variant="light">
                      <p>
                        El descriptor para esta función no está completo, ¿Desea
                        completarlo ahora,{" "}
                        <Link
                          to={`/descriptores-perfiles/seleccion-del-descriptor/${
                            functionSelected && functionSelected.id
                              ? functionSelected.id
                              : ""
                          }/${
                            functionSelected && functionSelected.descripcion
                              ? functionSelected.descripcion
                              : ""
                          }`}
                          // target="_blank"
                        >
                          si
                        </Link>{" "}
                        o{" "}
                        <Link
                          onClick={() => {
                            setViewMessege(false);
                            setContinue(false);
                          }}
                        >
                          no
                        </Link>
                        ?
                      </p>
                    </Alert>
                  </div>
                ) : null}
                {!_continue ? (
                  <div className="mb-1 border-left border-danger">
                    <Alert className="mb-0" variant="light">
                      <p>Seleccione otra función para poder continuar.</p>
                    </Alert>
                  </div>
                ) : null}
                <Table responsive>
                  <tbody>
                    {tasks.map((task) => (
                      <tr>
                        <td>
                          {task.codigo} / {task.descripcion}
                        </td>
                        <td>
                          <ButtonGroup>
                            <OverlayTrigger
                              placement="left"
                              overlay={
                                <Tooltip
                                  style={{ zIndex: 999999999999 }}
                                  {...props}
                                >
                                  Seleccionar función
                                </Tooltip>
                              }
                            >
                              <Button
                                variant="light"
                                size="sm"
                                className="rounded-circle mr-1"
                                onClick={() => {
                                  setFunctionSelected(task);
                                  setFuncion(true);
                                  setContinue(true);
                                  dispatch(
                                    getGeneralInfo({
                                      tipo_busqueda: "posicion_id",
                                      filter: parseInt(task.id),
                                    })
                                  );
                                }}
                              >
                                <i className="material-icons">add</i>
                              </Button>
                            </OverlayTrigger>
                            <LinkDescriptor
                              loader={
                                loadingGeneralInfo ||
                                jobLoading ||
                                experienceLoading ||
                                technicalKnowledgeAcquiredLoading ||
                                preparationLoading ||
                                trainingLoading ||
                                loaderIndikators
                              }
                              value={task}
                              functionSelected={functionSelected}
                            />
                          </ButtonGroup>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            ) : (
              <Alert variant="info" className="my-4">
                Sin registros que mostrar.
              </Alert>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CompetencyQuestions;
